import { getEnumLookup } from '../_helpers/enum-helper';

export enum SampleTypeEnum {
    Air = 0,
    Noise = 1,
    Wipe = 2,
    Biological = 3,
    Other = 4,
    Vibration = 5
}

/**
 * Sample types offered in the capture form. Other and Vibration are agent-type-only
 * classifications with no sample capture in the product, so they are hidden from the dropdown.
 * The current value is preserved on the edit path: if an existing sample already carries one of
 * these types, that option is kept so the field never renders blank and the value is not silently
 * lost on save (mirrors getFilteredSampleStatuses).
 */
export function getSelectableSampleTypes(currentSampleType?: number | null): { id: number; name: string }[] {
    const hiddenTypes = [SampleTypeEnum.Other, SampleTypeEnum.Vibration];
    return getEnumLookup(SampleTypeEnum).filter(
        t => !hiddenTypes.includes(t.id) || t.id === currentSampleType
    );
}
